import {createAction} from "@reduxjs/toolkit";

import {UserSource} from "../../tracking/tracking_utils/user_source";
import {RegistrationMethod, SocialMediaType} from "../state/registration_flow_slice";
import {AuthActionType} from "../types/AuthActionType";

export interface IAuthSucceededPayload {
    type: AuthActionType;
    userSource: UserSource;
    gtmSourceSection?: string;
    registrationMethod: RegistrationMethod;
    socialMediaType?: SocialMediaType;
}

/**
 * Event dispatched when user authentication (login or registration) succeeds.
 */
export const authSucceeded = createAction<IAuthSucceededPayload>("auth/succeeded");
